import { Component, ElementRef, ViewChild, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ACustomStepWizard } from '../../../shared/components/wizard/step-wizard/abstract-custom-step-wizard';
import { Observable, of } from 'rxjs';
import { InfoDialogComponent } from '../../../shared/components/info-dialog/info-dialog.component';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';

@Component({
  selector: 'app-import-step30',
  templateUrl: './import-step30.component.html',
  styleUrls: ['./import-step30.component.scss']
})
export class ImportStep30Component implements OnChanges {
  @Input() data;
  @Input() onNext = false;
  @Input() onBackClick = false;
  @Output() isValidEmit = new EventEmitter<boolean>();
  @ViewChild('infoDialog', { static: false }) infoDialog: InfoDialogComponent;
  @ViewChild('fileUpload', { static: false }) fileUploader: ElementRef;

  public isLoading = false;
  public showError = false;
  public errorMessage: string;

  constructor() {
  }

  ngOnChanges(): void {
    if (this.data) {
      this.data.syncData.OverrideTargetResources = true;
    }

    if (this.onNext)
      this.isValid();

    if (this.onBackClick)
      this.load();
  }

  public load() {
  }

  public isValid() {
    if (this.onNext) {
      let validation = true;
      if (!this.data.syncData.FilePath || this.data.syncData.FilePath.length === 0) {
        validation = false;
        this.showError = true;
        this.errorMessage = 'SYNC_DATA.MUST_SELECT_THE_FILE';
      }
      this.isValidEmit.emit(validation);
    }
  }

  public addFiles() {
    this.fileUploader.nativeElement.click();
  }

  public onFilesAdded() {
    if (this.fileUploader.nativeElement.files[0]) {
      this.showError = false;
      this.data.syncData.FileToImport = this.fileUploader.nativeElement.files[0];
      this.data.syncData.FilePath = this.data.syncData.FileToImport.name;
      this.fileUploader.nativeElement.value = '';
    }
  }
  public setData(data) {
    this.data = _.extend(this.data, data);
  }
}
